module.exports = __webpack_public_path__ + "img/Hummingbirds_2_MockedUp.dd17a2f7.jpg";